import React, { useRef, useEffect, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import '../static/SignaturePad.css'; 
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const SignaturePad = () => {
   
      
  const [responseMessage ,setResponseMessage] = useState('');

  const sigCanvas = useRef(null);
  const [owner, setOwner] = useState('');
  const [phone, setPhone] = useState('');
  const [pet, setPet] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const petData  = location.state?.owner;
 
useEffect(() => {
    if (!petData) {
    console.warn("No petData received — likely direct navigation or refresh.");
    // Optionally redirect:
    // navigate('/'); or show a message
    return;
  }
  if (petData) {
    console.log("petData received in PetForm:", petData);
    setOwner(petData); // Set full petData object (not just petData.owner)
    setPhone(petData.phone); 
    setPet(petData.pet); 
  }
}, [petData]);


  const clear = () => {
    sigCanvas.current?.clear();
  };

  const save = () => {
    if (sigCanvas.current) {
      const dataUrl = sigCanvas.current.getCanvas().toDataURL("image/png");
      console.log('Saved Signature DataURL:', dataUrl);
    }
  }


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!sigCanvas.current || sigCanvas.current.isEmpty()) {
    alert('Please provide a signature before submitting.');
    return;
  }

  const dataUrl = sigCanvas.current.getCanvas().toDataURL("image/png");

  try {
    const response = await axios.post('/create-signature/', {
      phone: phone,
  signature: dataUrl,
    });

    if (response.status === 201) {
      const returnedOwner = response.data.owner;
      const returnedId = response.data.id;
alert(`Phone: ${phone}`);
      alert(`Owner ID: ${returnedOwner}, Pet ID: ${returnedId}, Phone: ${owner.phone_mobile}`);

      try {
const queryParams = new URLSearchParams({ phone }).toString();
        const res = await fetch(`/fetch-pet/?${queryParams}`);

        if (!res.ok) {
          setResponseMessage('Pet not found.');
          alert('No Pet');
          return;
        }

        const data = await res.json();

        const query = new URLSearchParams({
          id: data.id || '',
          name: data.name || '',
          catdog: data.catdog || '',
          owner: data.owner || '',
          image: data.image || '',
          phone: data.phone || '',
          breed: data.breed || '',
          age: data.age?.toString() || '',
          behaviour: data.behaviour || '',
          allergies: data.allergies || '',
          vaccinated: data.vaccinated?.toString() || '',
          grooming_history: data.grooming_history || '',
          booking_date: data.booking_date || '',
          extra_info: data.extra_info || '',
          text: data.text || ''
        }).toString();

        navigate(`/historygroom/?${query}`);
      } catch (error) {
        console.error('Error fetching pet:', error);
        setResponseMessage('An error occurred. Please try again.');
      }
    }
  } catch (error) {
  if (error.response) {
    console.error('Server responded with error:', error.response.status, error.response.data);
    alert(`Submission failed: ${error.response.data.message || 'Server error'}`);
  } else if (error.request) {
    console.error('No response received:', error.request);
    alert('No response from server. Please check your network.');
  } else {
    console.error('Error setting up request:', error.message);
    alert(`Error: ${error.message}`);
  }
}

};

  return (
    <div className="signature-container">
 
      <section className="contact-wrap">
        <form onSubmit={handleSubmit} className="contact-form" encType="multipart/form-data">
        <div className="signature-container">
        <SignatureCanvas
          penColor="black"
          canvasProps={{ wwidth: "100%", height: "auto", className: "sigCanvas" }}
          ref={sigCanvas}
          style={{ width: "100%", height: "auto", borderRadius: "6px" }}
        />
      </div>
      
       <div className="input-block">
                
                <input type="text" readOnly value={phone} onChange={(e) => setPhone(e.target.value)} className="form-control" />

            </div>
             <label>Pet ID: {pet}</label>
             <div className="input-block">
               
                <input type="hidden" readOnly value={pet} onChange={(e) => setPet(e.target.value)} className="form-control" />

            </div>
             
          <div style={{ marginTop: "10px" }}>
            <button type="submit" className='button'>Sign and send</button>
            <button type="button" onClick={clear} className='button'>Clear</button>
          </div>
        </form>
      </section>
    </div>
  );
};

function dataURLtoBlob(dataurl) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while(n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export default SignaturePad;
